import { render, staticRenderFns } from "./TableHeaderButtons.vue?vue&type=template&id=6505781f"
import script from "./TableHeaderButtons.vue?vue&type=script&lang=ts"
export * from "./TableHeaderButtons.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports